export const tables = () => {
    // Select all WordPress table blocks
    const tables = document.querySelectorAll('.wp-block-table table');
  
    tables.forEach((table) => {
      // Get all headers
      const headers = Array.from(table.querySelectorAll('thead th')).map(th => th.textContent.trim());
  
      // Add data-label to each cell
      table.querySelectorAll('tbody tr').forEach(row => {
        row.querySelectorAll('td').forEach((cell, i) => {
          if (headers[i]) {
            cell.setAttribute('data-label', headers[i]);
          }
        });
      });
  
      // Wrap table for horizontal scroll fallback
      if (table.parentElement.classList.contains('is-responsive')) {
        const wrapper = document.createElement('div');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
  };